import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { ChannelSettingsComponent } from 'app/pages/ChannelSettingsComponent/Loadable';
import { DealerSendingCalendarSettingsComponent } from 'app/pages/DealerSendingCalendarSettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_CALENDAR } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useCalendarConfigurationPage } from './hooks/useCalendarConfigurationPage';

const CalendarConfigurationPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useCalendarConfigurationPage();

  return (
    <>
      <Helmet>
        <title>Calendar configuration</title>
        <meta
          name="description"
          content="Configure channel settings for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Channel settings"
        headerSubtitle={
          hasDealer ? (
            <DealerPageHeaderEntityInfo
              title={dealerTitle}
              dealerId={dealerId}
            />
          ) : undefined
        }
        contentVariant="centered"
      >
        <DealerSendingCalendarSettingsComponent />
        <ChannelSettingsComponent />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  CalendarConfigurationPage,
  CONFIGURE_RESOURCE_CALENDAR,
);
